import { render, staticRenderFns } from "./IconPaperPlane.vue?vue&type=template&id=14f751d0&scoped=true"
import script from "./IconPaperPlane.vue?vue&type=script&lang=js"
export * from "./IconPaperPlane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f751d0",
  null
  
)

export default component.exports